import { RouteObject } from 'react-router-dom';
import AuthPage from './auth.page';
import { PhoneForm } from './components/auth/phone-form';
import { VerifyForm } from './components/auth/verify-form';
import { TwoStepVerifyForm } from './components/auth/two-step-verify-form';

const authRoutes: RouteObject = {
    path: '',
    element: <AuthPage />,
    children: [
        {
            path: '',
            element: <PhoneForm />,
        },
        {
            path: 'verify',
            element: <VerifyForm />,
        },
        {
            path: 'password',
            element: <TwoStepVerifyForm />,
        },
    ],
};

export default authRoutes;
